import { render, staticRenderFns } from "./dp-decor-title.vue?vue&type=template&id=4f26122a"
import script from "./dp-decor-title.vue?vue&type=script&lang=js"
export * from "./dp-decor-title.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports